<div class="modal-header">

  <h4 class="modal-title"
  [translate]="getModalTitle()"></h4>
  <button class="btn-close" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">

  <form name="assignServiceMeasuringPoint">
    <div class="row">

      <div class="col-12">
        <label class="form-label" for="searchMeasuringPoint">{{ 'measuringPoints.table.filter.measuringPoint' | translate }}*</label>
        <app-search-measuring-point id="searchMeasuringPoint" #searchMeasuringPointComponent
          (selectedMeasuringPointEvent)="measuringPointSelected($event)"
          [defaultMeasuringPoint]="measuringPoint"
          [serviceId]="reassignCustomerMode ? serviceId : null"
          [serviceUnassignedOnly]="!reassignCustomerMode"
          [customerUnassignedOnly]="reassignCustomerMode"
          [measuringPointTypes]="[measuringPointTypeToAdd]"
        [disabled]="assignCustomerMode"></app-search-measuring-point>
      </div>

      @if (measuringPointTypeToAdd === measuringPointType.Customer) {
        <div class="col-12">
          <label class="form-label" for="searchCustomer">{{ 'measuringPoints.table.filter.user' | translate }}</label>
          <app-search-customer id="searchCustomer" #searchCustomerComponent
            (selectedCustomerEvent)="customerSelected($event)"
            [customerContact]="customer"
          [disabled]="reassignCustomerMode"></app-search-customer>
        </div>
      }

    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary"
    (click)="activeModal.close()"
    translate="common.cancel">
  </button>
  <button class="btn btn-primary" type="submit"
    [disabled]="measuringPointId === null"
    (click)="assignMeasuringPoint()"
    translate="common.save">
  </button>
</div>
